if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelectorAll('[data-media-step]').forEach((button) => {
          button.addEventListener('click', () => this.moveMedia(Number(button.dataset.mediaStep)));
        });
        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open') || event.target.closest('deferred-media, product-model, input, textarea')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.moveMedia(event.key === 'ArrowLeft' ? -1 : 1);
          }
        });
      }

      show(opener) {
        super.show(opener);
        const allMedia = [...this.querySelector('.product-media-modal__content').children];
        const selected = allMedia.find((media) => media.dataset.mediaId === opener.dataset.mediaId) || allMedia[0];
        this.items = allMedia.filter((media) =>
          !media.classList.contains('product__media-item--variant') || media === selected
        );
        this.querySelectorAll('[data-media-step]').forEach((button) => {
          button.hidden = this.items.length < 2;
        });
        this.showActiveMedia(selected);
      }

      moveMedia(step) {
        if (!this.items?.length) return;
        const index = (this.items.indexOf(this.activeMedia) + step + this.items.length) % this.items.length;
        window.pauseAllMedia();
        this.showActiveMedia(this.items[index]);
      }

      showActiveMedia(activeMedia) {
        if (!activeMedia) return;
        this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((media) => {
          media.classList.toggle('active', media === activeMedia);
        });
        this.activeMedia = activeMedia;
        this.querySelector('.product-media-modal__counter').textContent =
          `${this.items.indexOf(activeMedia) + 1} / ${this.items.length}`;
        const template = activeMedia.querySelector('template');
        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && template?.content.querySelector('.js-youtube')) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
